import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { plateformSettingServices } from "../../APIServices/GlobalManagements/plateformSettingServices";

const CustomizeThemeColors = ({ Show, Hide, Title, plateformSettings }) => {
  const [primaryColor, setPrimaryColor] = useState("#007bff");
  const [secondaryColor, setSecondaryColor] = useState("#6c757d");
  const handleApplyColors = async () => {
    let userData = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor,
    };
    let data =
      await plateformSettingServices.addUpdatePlateformSettings(userData);
    if (data?.statusCode === 200) {
      document.documentElement.style.setProperty("--primary", primaryColor);
      document.documentElement.style.setProperty("--secondary", secondaryColor);
      localStorage.setItem("primaryColor", primaryColor);
      localStorage.setItem("secondaryColor", secondaryColor);
      Hide();
    }
  };

  const handleResetColors = async () => {
    let userData = {
      primaryColor: "#007bff",
      secondaryColor: "#6c757d",
    };
    let data =
      await plateformSettingServices.addUpdatePlateformSettings(userData);
    if (data?.statusCode === 200) {
      setPrimaryColor("#007bff");
      setSecondaryColor("#6c757d");
      document.documentElement.style.setProperty("--primary", "#007bff");
      document.documentElement.style.setProperty("--secondary", "#6c757d");
      localStorage.setItem("primaryColor", "#007bff");
      localStorage.setItem("secondaryColor", "#6c757d");
    }
  };

  useEffect(() => {
    if (plateformSettings) {
      setPrimaryColor(plateformSettings?.primaryColor || "#007bff");
      setSecondaryColor(plateformSettings?.secondaryColor || "#6c757d");
    }
  }, [plateformSettings]);

  return (
    <>
      <Modal show={Show} onHide={() => Hide()}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 15 }}>{Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Primary Color</label>
            <div className="d-flex gap-2 align-items-center">
              <Form.Control
                type="color"
                className="p-0"
                style={{ width: "40px", height: "35px", cursor: "pointer" }}
                value={primaryColor}
                onChange={(e) => setPrimaryColor(e.target.value)}
              />
              <Form.Control
                type="text"
                value={primaryColor}
                onChange={(e) => setPrimaryColor(e.target.value)}
                placeholder="#007bff"
              />
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Secondary Color</label>
            <div className="d-flex gap-2 align-items-center">
              <Form.Control
                type="color"
                className="p-0"
                style={{ width: "40px", height: "35px", cursor: "pointer" }}
                value={secondaryColor}
                onChange={(e) => setSecondaryColor(e.target.value)}
              />
              <Form.Control
                type="text"
                value={secondaryColor}
                onChange={(e) => setSecondaryColor(e.target.value)}
                placeholder="#6c757d"
              />
            </div>
          </div>
          <div
            className="mt-4 p-3 border rounded"
            style={{ backgroundColor: "var(--button-bg)" }}
          >
            <small className="text-muted d-block mb-2">Preview:</small>
            <div className="d-flex gap-2">
              <div
                style={{
                  backgroundColor: primaryColor,
                  width: "35px",
                  height: "35px",
                  borderRadius: "4px",
                }}
                title="Primary Color"
              />
              <div
                style={{
                  backgroundColor: secondaryColor,
                  width: "35px",
                  height: "35px",
                  borderRadius: "4px",
                }}
                title="Secondary Color"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="sm"
            variant="outline-danger"
            style={{ fontSize: 12 }}
            onClick={handleResetColors}
          >
            Reset
          </Button>
          <Button
            size="sm"
            variant="primary"
            onClick={handleApplyColors}
            style={{
              fontSize: 12,
              backgroundColor: primaryColor,
              borderColor: primaryColor,
            }}
          >
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomizeThemeColors;
